import React, { useState } from 'react';
import Settings from './Settings';
import { StyledTab } from '@/app/customComponents/Tabs/StyledTab';
import StyledTabs from 'shared/components/StyledTabs';
import FuseAnimate from '@/@fuse/core/FuseAnimate';
import { AppBar } from '@material-ui/core';

const SettingTab = () => {
	const [activeTab, setActiveTab] = useState(0);

	const handleChange = (_, newValue) => {
		setActiveTab(newValue);
	};

	return (
		<FuseAnimate animation="transition.slideLeftIn" duration={600}>
			<div>
				<div className="flex items-center gap-16 bg-white shadow-lg">
					<AppBar className="shadow-none flex-1 z-[2]" position="static">
						<StyledTabs onChange={handleChange} value={activeTab} variant="scrollable">
							<StyledTab
								className={`text-pd-base md:text-pd-lg ${activeTab === 0 ? 'text-pd-blue' : ''}`}
								label="Settings"
								value={0}
							/>
						</StyledTabs>
					</AppBar>
				</div>

				<div className="overflow-auto mb-64 pb-64">{activeTab === 0 ? <Settings /> : null}</div>
			</div>
		</FuseAnimate>
	);
};

export default SettingTab;
